import { Outlet, Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import HeaderNoNav from "./HeaderNoNav";
import logo from "../assets/alist logo.png";
import logoMark from "../assets/logomark.svg";

const HomeNav = () => (
  <nav className="navbar bg-dark border-body" data-bs-theme="dark">
    <div className="container">
        <a className="navbar-brand" href="/">
          <img src={logo} alt="Logo" className="d-inline-block align-text-top"/>
        </a>
        <span>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav">
              <li>
                <Link to="/form">Form</Link>
              </li>
            </ul> 
          </div>
        </span> 
      </div>
    </nav>
  );

const MobileNav = () => {
  return (
    <nav className="navbar border-body" data-bs-theme="dark">
    <div className="container">
      <a className="navbar-brand" href="/">
        <img src={logoMark} alt="Logo" className="d-inline-block align-text-top"/>
      </a>
    </div>
  </nav>
  ) 
};

//{location.pathname !== '/searchResults' ? <MobileNav /> : <div/>}

export default function Layout() {
  const location = useLocation();
  if (window.innerWidth < 700) {
    return (
      <div>
        <MobileNav/>
        <Outlet/>
        
      </div>
    );
  } else {
    return (
      <div>
        {location.pathname === '/' ? <HomeNav /> : <HeaderNoNav />}
        <Outlet/>
      </div>
    );

  } 
}